import "./Footer.scss";
import logo from './../../common/assets/img/AMIG-logo-withTagline.png';
import { Box, Link, IconButton } from '@mui/material';
import appSettings from '../../appSettings';

const Footer = () => {

  const socialLinks = [
    { name: 'Facebook', url: appSettings.AMIG_FB, icon: 'fb-icon-white' },
    { name: 'LinkedIn', url: appSettings.AMIG_LINKEDIN, icon: 'linkedin-icon-white' },
    { name: 'Youtube', url: appSettings.AMIG_YOUTUBE, icon: 'youtube-icon-white' }
  ];

  const handleLegalLinkClick = () => {
    window.UC_UI.showSecondLayer();
};

  return (

    <Box className="footer-container">
      <Box className="footer">
        <Box> <Box className="footer-logo">
          <Link aria-label="American Modern Logo" href="https://agents.amig.com">
            <img className="footer-logo-img" src={logo} alt="American Modern Logo" />
          </Link>
        </Box>
        <Box className="social-icons">
            {
              socialLinks.map((elem, index) => (
                <IconButton key={'social-icon-'+index} className='social-icon' aria-label={elem.name} onClick={() => {
                  window.open(elem.url, '_blank');
                }}>
                  <img
                    src={require('../../common/assets/img/' + elem.icon + '.png')}
                    alt='social icon'
                  />
                </IconButton>
              ))
            }
          </Box>
        </Box>
        <Box className="footer-content">
          <Box className="footer-text-content">
            <Box>Coverage is subject to policy terms, conditions, limitations, exclusions, underwriting review and approval, and may vary or not be available for all risks or in all states. Rates and discounts vary, are determined by many factors, and are subject to change. Policies are written by one of the licensed insurers of American Modern Insurance Group, Inc., including but not limited to American Modern Property and Casualty Insurance Company (CA Lic. No. 6129-1).</Box>
            <Box>American Modern Insurance Group, American Modern, AMsuite, AMsuite+, and Homeowners FLEX are registered trademarks of American Modern Insurance Group, Inc. All other names, logos, and brands described herein are trademarks or registered trademarks of their respective holders, and use herein does not imply affiliation with or sponsorship or endorsement by them of American Modern, its products, or its services.</Box>
            <Box>Please refer to the applicable Homeowners FLEX Program Manual for complete details. Different sub-limits may apply that vary from a standard HO-3 policy. “All risk” pertains specifically to dwellings and structures. Mandatory exclusions, including roof cosmetic damage exclusion and swimming pool slide and diving board liability exclusion, apply.</Box>
          </Box>
          <Box className="footer-legal-links">
            <Box className="legal-links">
              <Link href={appSettings.AMIG_PRIVACY} aria-label='Privacy' target='_blank' className='legal-link' underline='hover'>Privacy</Link>
              <Box className='vertical-divider'>|</Box>
              <Link href={appSettings.AMIG_CAL_PRIVACY} aria-label='California Privacy' target='_blank' className='legal-link' underline='hover'>California consumer privacy rights</Link>
              <Box className='vertical-divider'>|</Box>
              <Link href={appSettings.AMIG_TERMS_OF_USE} aria-label='Terms of use' target='_blank' className='legal-link' underline='hover'>Terms of use</Link>
              <Box className='vertical-divider'>|</Box>
              <Link className='legal-link' onClick={handleLegalLinkClick} underline='hover'>Cookie settings</Link>
            </Box>
            <Box className='copyright'>©{new Date().getFullYear()}. American Modern Insurance Group, Inc. <Box className='rights-reserved'>All rights reserved.</Box></Box>
          </Box>
        </Box>
      </Box>
    </Box>

  )
}

export default Footer;
